module.exports = __webpack_public_path__ + "img/42.6615b37.jpg";